import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useMotivosOuvidoriaNavegacao = () => {
  const history = useHistory();

  const handleRowClick = useCallback(
    row => {
      history.push(`/pages/motivoouvidoria/${row.id}`);
    },
    [history]
  );

  const handleAdicionar = useCallback(() => {
    history.push('/pages/motivoouvidoria/criar');
  }, [history]);

  const handleEditar = useCallback(
    id => {
      history.push(`/pages/motivoouvidoria/editar/${id}`);
    },
    [history]
  );

  return {
    handleRowClick,
    handleAdicionar,
    handleEditar,
  };
};
